import { Control, FieldValues, UseFormWatch } from 'react-hook-form';

import { SelectWithControl } from 'components/SelectWithControl';

import * as S from './Inputs.styles';
import { useInputsData } from './useInputsData.hooks';

type InputsProps = {
  control: Control<FieldValues, any>; // eslint-disable-line
  watch: UseFormWatch<FieldValues>;
};

export function Inputs(props: InputsProps): React.ReactElement {
  const { control, watch } = props;

  const inputsData = useInputsData(watch);

  const inputsComponents = inputsData?.map((item) =>
    item.options.length > 0 ? (
      <SelectWithControl
        key={item.name}
        name={item.name}
        label={item.label}
        options={item.options}
        control={control}
      />
    ) : undefined
  );

  return <S.Container>{inputsComponents}</S.Container>;
}
